import { StatToColor, TypeToColor } from "./consts.js";

$(window).on("load", function () {
	Object.entries(TypeToColor).forEach(([type, color]) => {
		$(":root").css(`--type${type}`, color);
	});

	Object.entries(StatToColor).forEach(([stat, color]) => {
		$(":root").css(`--stat${stat}`, color);
	});
});